<template>
  <md-snackbar
    :md-position="position"
    :md-duration="isInfinity ? Infinity : duration"
    :md-active.sync="showSnackbar"
    md-persistent
  >
    <span>Report not ready yet! We are generating it.</span>
  </md-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  data: () => ({
    position: "center",
    duration: 4000,
    isInfinity: false
  }),
  props: ["showSnackbar"]
};
</script>
